import { useLocalization } from '@shopify/hydrogen'
import { Image, Metafield } from '@shopify/hydrogen/storefront-api-types'

export interface AcfImage {
  alt: string
  aspect_ratio: number
  cloudinary_src: string
  id: string
  filename: string
  handle: string
  height: number
  key: string
  media_type: string
  mime_type: string
  original_src: string
  scope: string
  src: string
  width: number
}

export interface AcfMarkdown {
  html: string
  markdown: string
}

export const parseAcf = <T>(field: Metafield): T | undefined => {
  if (!field) {
    return
  }

  const {
    language: { isoCode: language },
  } = useLocalization()

  try {
    const value = JSON.parse(field.value)
    return language.toLowerCase() in value ? value[language.toLowerCase()] : value
  } catch (e) {
    return field.value as T
  }
}

export const parseAcfImage = (acfImage?: AcfImage[]): Image | undefined => {
  if (!acfImage) {
    return
  }

  const [image] = acfImage

  return {
    altText: image.alt,
    height: image.height,
    id: image.id,
    originalSrc: image.cloudinary_src,
    src: image.cloudinary_src,
    transformedSrc: image.cloudinary_src,
    url: image.cloudinary_src,
    width: image.width,
  }
}

export const parseAcfRepeater = <T>(field: Metafield) => {
  const {
    language: { isoCode: language },
  } = useLocalization()

  const valueArray: {
    [key: string]: T
  }[] = JSON.parse(field.value)

  return valueArray.map((value) => (language.toLowerCase() in value ? value[language.toLowerCase()] : (value as T)))
}
